import React from "react";
import BotonAumentar from "../../../../componentsUI/formularios/button/ButtonAumentar.js";
import BotonDisminuir from "../../../../componentsUI/formularios/button/ButtonDisminuir.js";
import "../../../../componentsUI/formularios/button/Button.css";

export default function BotoneraMasMenos({
  id,
  cantidad,
  onCantidadChange
}) {
  const aumentar = () => {
    onCantidadChange?.(id, cantidad + 1);
  };

  const disminuir = () => {
    onCantidadChange?.(id, Math.max(cantidad - 1, 0));
  };

  return (
    <div className="botonera-uix">
      <BotonDisminuir onSelect={disminuir} />
      <span className="contador">{cantidad}</span>
      <BotonAumentar onSelect={aumentar} />
    </div>
  );
}
